export const RE_APPLY_LENDER = {
    cic: {
        en: 'Community Investment Corporation',
        es: 'Community Investment Corporation'
    },
    trad: {
        en: 'Traditional Bank or Credit Union',
        es: 'Banco tradicional o cooperativa de ahorro y crédito'
    },
    online: {
        en: 'Online Lender',
        es: 'Prestamista en línea'
    },
    alt: {
        en: 'Alternative Lender (another nonprofit, SBA lender, etc.)',
        es: 'Prestamista alternativo (otra organización sin fines de lucro, prestamista de la SBA, etc.)'
    },
    personal: {
        en: 'Personal Connection (Friend, Family, Business Associate, etc.)',
        es: 'Conexión personal (amigo, familia, socio comercial, etc.)'
    },
    rev: {
        en: 'Revenue-Based Financing (e.g. Merchant Cash Advances through Square, PayPal, etc.)',
        es: 'Financiamiento basado en ingresos (por ejemplo, anticipos en efectivo al comerciante a través de Square, PayPal, etc.)'
    },
    angel: {
        en: 'Angel Investor',
        es: 'Inversionista ángel'
    },
    other: {
        en: 'Other',
        es: 'Otro'
    }
} as Record<string, { en: string; es: string }>;
